import React, { useEffect, useState } from "react";
import "./AdminUserManagement.css";
import EditModal from "./ActionModals/EditModal";
import { postData, deleteData, putData } from "../../../Services/Api";
import { GetUserDetails } from "../../../Helpers/Utility";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ColorRing } from "react-loader-spinner";
import SearchIcon from "../../../Assets/Images/SearchIcon.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faQrcode } from "@fortawesome/free-solid-svg-icons";
import QRCodeModal from "./ActionModals/QRCodeModal";
import AddModal from "./ActionModals/AddModal";

export default function AdminUserManagement() {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [recordCount, setRecordCount] = useState(0);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userToken, setUserToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Add this state
  const [serverList, setServerList] = useState([]);
  const [OpenTab, setOpenTab] = useState([]);

  const [show, setShow] = useState(false);
  const [data, setData] = useState({});

  const [timeOutId, setTimeoutId] = useState(-1);

  const usersPerPage = 10; // Number of users to display per page

  const getServerList = async () => {
    const userDetails = GetUserDetails();
    try {
      const response = await postData(
        "vpn-servers-list",
        {
          search_text: "",
          page_number: 1,
          limit: 10,
          sortBy: "created_at",
          sortAscDesc: "desc",
        },
        {
          Authorization: `Bearer ${userDetails.token}`,
        }
      );
      setServerList(response?.data?.data?.["server-lists"] || []);
    } catch (err) {
      console.log(err);
    }
  };

  const toggleTab = (ev, id) => {
    // Find the index of the element
    if (OpenTab.includes(id)) {
      setOpenTab((dt) => dt.filter((ele) => ele != id)); // Remove the element at the index
      return;
    }
    setOpenTab((dt) => [...dt, id]);
  };

  const getsubscriberList = async (token, page) => {
    if (!token) {
      return;
    }

    setUserToken(token);

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const data = {
      search_text: searchText,
      page_number: page,
      limit: usersPerPage,
      sortBy: "created_at",
      sortAscDesc: "desc",
    };

    setLoading(true);
    const getDataResponse = await postData("subscribers-list", data, headers);
    setLoading(false);
    const { subscribers, currentPage, recordCount, totalPageCount } =
      getDataResponse?.data?.data || {};
    setUsers(subscribers || []);
    setCurrentPage(currentPage || 1);
    setRecordCount(recordCount || 0);
    setTotalPages(totalPageCount || 1);
    setOpenTab([]);
  };

  useEffect(() => {
    const userDetails = GetUserDetails();
    if (userDetails?.token) {
      getsubscriberList(userDetails?.token, currentPage);
      getServerList();
    }
  }, [currentPage, searchText]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEditClick = (ev, user) => {
    ev.stopPropagation();
    setSelectedUser(user);
    setEditModalOpen(true);
  };

  const handleClose = () => {
    setSelectedUser(null);
    setEditModalOpen(false);
  };

  const updateUserList = async () => {
    const userDetails = GetUserDetails();
    if (userDetails?.token) {
      await getsubscriberList(userDetails?.token, currentPage);
    }
  };

  const openQRcode = async (ev, server, user, serverData) => {
    ev.preventDefault();
    setData(
      server
        ? server
        : {
            user_subscribers_id: user.id,
            location_server_id: serverData.id,
          }
    );
    setShow(true);
  };

  const getData = async (ev, server, user, serverData) => {
    ev.preventDefault();
    try {
      const { token } = GetUserDetails();
      const { user_subscribers_id, location_server_id } = {
        user_subscribers_id: user.id,
        location_server_id: serverData.id,
      };
      const response = await postData(
        "get-vless-url",
        {
          user_subscribers_id,
          location_server_id,
        },
        {
          Authorization: `Bearer ${token}`,
        }
      );
      if (response?.data?.uuid) {
        addUid(location_server_id, user_subscribers_id, response?.data?.uuid);
      } else if (response?.message) {
        toast.error(response?.message);
      } else {
        toast.error("Data not found");
      }
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    }
  };

  const addUid = async (serverId, userId, uuid) => {
    setUsers((dt) =>
      dt.map((ele) => {
        if (ele.id == userId) {
          if (
            ele.connected_location.find(
              (ele) => ele.location_server_id == serverId
            )
          ) {
            ele.connected_location = ele.connected_location.map((loc) => {
              if (loc.id == serverId) loc.uuid = uuid;
              return loc;
            });
          } else {
            ele.connected_location.push({
              id: Symbol(),
              uuid: uuid,
              user_subscribers_id: userId,
              location_server_id: serverId,
            });
          }
        }
        return ele;
      })
    );
  };

  const handleSearchChange = (e) => {
    if (timeOutId) clearTimeout(timeOutId);
    setTimeoutId(
      setTimeout(() => {
        setSearchText(e.target.value);
        setCurrentPage(1); // Reset to first page on search
      }, 500)
    );
  };

  const userDetails = GetUserDetails();
  if (!userDetails?.token) {
    return;
  }

  const headers = {
    Authorization: `Bearer ${userDetails.token}`,
  };

  const handleSuspendToggle = async (ev, userId, isSuspended) => {
    ev.stopPropagation();
    ev.preventDefault();
    confirmAlert({
      title: "Confirm to change suspension",
      message: "Are you sure to change suspension status of user?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              const updatedUsers = users.map((user) => {
                if (user.id === userId) {
                  return { ...user, is_suspended: isSuspended ? 0 : 1 };
                }
                return user;
              });

              setUsers(updatedUsers);

              const sendData = {
                user_id: userId,
                is_suspended: isSuspended ? 0 : 1,
              };

              const getDataResponse = await putData(
                "update-subscriber-suspended",
                sendData,
                headers
              );
              if (!getDataResponse.success) {
                // Revert back the changes if the API call fails
                const revertedUsers = users.map((user) => {
                  if (user.id === userId) {
                    return { ...user, is_suspended: isSuspended ? 1 : 0 };
                  }
                  return user;
                });
                setUsers(revertedUsers);
                console.error(
                  "Failed to update suspend status:",
                  getDataResponse.message
                );
              }
            } catch (err) {
              console.log(err);
            }
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  const handleDeleteClick = (ev, userId) => {
    ev.stopPropagation();
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure to delete this user?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              const sendData = {
                user_id: userId,
                is_deleted: 1,
              };

              const getDataResponse = await deleteData(
                "delete-subscriber",
                sendData,
                headers
              );

              if (getDataResponse.success) {
                // Update the users state to remove the deleted user
                setUsers((prevUsers) =>
                  prevUsers.filter((user) => user.id !== userId)
                );
                // toast.success("User deleted successfully");
              } else {
                console.error(
                  "Failed to delete user:",
                  getDataResponse.message
                );
                toast.error("Failed to delete user");
              }
            } catch (error) {
              console.error("Error deleting user:", error);
              toast.error("An error occurred while deleting the user");
            }
          },
        },
        {
          label: "No",
          onClick: () => console.log("Delete cancelled"),
        },
      ],
    });
  };

  const renderPagination = () => {
    const pageNumbers = [];
    const maxPagesToShow = isMobile ? 2 : 5; // Show only 2 pages on mobile

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const startPages = [1];
      const endPages = [totalPages];
      let middlePages = [];

      if (currentPage <= 2) {
        middlePages = [2];
      } else if (currentPage >= totalPages - 1) {
        middlePages = [totalPages - 1];
      } else {
        middlePages = [currentPage];
      }

      pageNumbers.push(...startPages);

      if (middlePages[0] > 2) {
        pageNumbers.push("...");
      }

      if (isMobile) {
        middlePages = [2]; // Fixed middle page for mobile
        pageNumbers.push(...middlePages);
        if (totalPages > 2) {
          pageNumbers.push("...");
          pageNumbers.push(totalPages);
        }
      } else {
        pageNumbers.push(...middlePages);
        if (middlePages[middlePages.length - 1] < totalPages - 1) {
          pageNumbers.push("...");
        }
        pageNumbers.push(...endPages);
      }
    }

    return pageNumbers.map((page, index) =>
      typeof page === "number" ? (
        <li
          key={index}
          className={`page-item ${currentPage === page ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(page)}>
            {page}
          </button>
        </li>
      ) : (
        <li key={index} className="page-item disabled">
          <span className="page-link">{page}</span>
        </li>
      )
    );
  };

  return (
    <section className="AdminUserManagement">
      {/* <ToastContainer /> */}
      <QRCodeModal
        addUid={addUid}
        show={show}
        handleClose={() => setShow(false)}
        userData={data}
      />
      <div className="AdminUserManagementTable">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-block headingAdmin py-3">
            <h2>User Lists</h2>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <button
              onClick={(ev) => setAddModalOpen(true)}
              className="btn d-flex justify-content-center align-items-center me-3"
              style={{ whiteSpace: "nowrap", fontSize: "18px" }}
            >
              <FontAwesomeIcon
                icon={faPlus}
                style={{
                  width: "25px",
                  height: "25px",
                  marginLeft: "10px",
                  cursor: "pointer",
                  color: "green",
                }}
              />
              <span className="ms-2">Add user</span>
            </button>
            <div className="input-group justify-content-end">
              <span className="input-group-text border-end-0 rounded-start-5 bg-white">
                <img src={SearchIcon} alt="Search" className="img-fluid" />
              </span>
              <input
                type="text"
                className="form-control searchTextBox rounded-end-5 border-start-0"
                style={{ maxWidth: "300px" }}
                placeholder="Search Here..."
                // value={searchText}
                onChange={handleSearchChange}
              />
            </div>
          </div>
        </div>
        <div className="AdminUserManagementTableSection bg-white p-2 px-0 rounded-4">
          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <ColorRing
                type="ThreeDots"
                color="#00BFFF"
                height={80}
                width={80}
              />
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th className="customTh" scope="col">
                      S.no
                    </th>
                    <th className="customTh" scope="col">
                      Name
                    </th>
                    <th className="customTh" scope="col">
                      Email
                    </th>
                    <th className="customTh" scope="col">
                      Subscription plan
                    </th>
                    <th className="customTh" scope="col">
                      Status
                    </th>
                    <th className="customTh" scope="col">
                      Suspended
                    </th>
                    <th className="customTh" scope="col">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, index) => (
                    <React.Fragment key={user.id+"er"}>
                      <tr
                        style={{ cursor: "pointer" }}
                        onClick={(ev) => toggleTab(ev, user.id)}
                        key={user.id}
                      >
                        <td className="customTd">{user.index}</td>
                        <td className="customTd">{user.subscriber_name}</td>
                        <td className="customTd">{user.email}</td>
                        <td className="customTd">{user.title || "N/A"}</td>
                        <td className="customTd">
                          {user.is_deleted === 1
                            ? "Deleted"
                            : user.is_suspended === 1
                            ? "Suspended"
                            : "Activated"}
                        </td>
                        <td className="customTd">
                          <div>
                            <div className="form-check customCheck form-switch">
                              <input
                                className="form-check-input customRange"
                                type="checkbox"
                                role="switch"
                                id={`flexSwitchCheckChecked${user.id}`}
                                checked={user.is_suspended === 1}
                                // readOnly
                                onChange={(ev) =>
                                  handleSuspendToggle(
                                    ev,
                                    user.id,
                                    user.is_suspended === 1
                                  )
                                }
                              />
                            </div>
                          </div>
                        </td>
                        <td className="customTd">
                          <div className="d-flex align-items-center">
                            <div
                              className="mx-2 mt-1 cursor-pointer"
                              onClick={(ev) => handleEditClick(ev, user)}
                            >
                              <i className="fa fa-edit editColor" />
                            </div>
                            <div
                              className="mx-1 cursor-pointer"
                              onClick={(ev) => handleDeleteClick(ev, user.id)}
                            >
                              <i className="fa fa-trash trashColor" />
                            </div>
                          </div>
                        </td>
                      </tr>
                      {OpenTab.includes(user.id) && (
                        <tr
                        key={user.id+"sd"}>
                          <td colSpan={7}>
                            <div className="row mx-3 py-1">
                              <div className="row py-2 border border-start-0 border-end-0 border-top-0">
                                <div
                                  className="customTh col-2 px-3"
                                  scope="col"
                                >
                                  Server ID
                                </div>
                                <div
                                  className="customTh col-4 px-3"
                                  scope="col"
                                >
                                  Name
                                </div>
                                <div
                                  className="customTh col-5 px-3"
                                  scope="col"
                                >
                                  UID
                                </div>
                                <div
                                  className="customTh col-1 px-3"
                                  scope="col"
                                >
                                  Action
                                </div>
                              </div>
                              {serverList.map((server, index) => (
                                <div
                                  className="row py-2 border border-start-0 border-end-0 border-top-0"
                                  key={server.id}
                                >
                                  <div className="col-2 px-3">{index + 1}</div>
                                  <div className="col-4 px-3">
                                    {server.name}
                                  </div>
                                  <div className="col-5 px-3">
                                    {user?.connected_location?.find(
                                      (loc) =>
                                        loc?.location_server_id == server.id
                                    )?.uuid || "-"}
                                  </div>
                                  <div className="col-1 px-3">
                                    {user?.connected_location?.find(
                                      (loc) =>
                                        loc?.location_server_id == server.id
                                    )?.uuid ? (
                                      <FontAwesomeIcon
                                        title="Generate QRCode"
                                        onClick={(ev) =>
                                          openQRcode(
                                            ev,
                                            user?.connected_location?.find(
                                              (loc) =>
                                                loc?.location_server_id ==
                                                server.id
                                            ),
                                            user,
                                            server
                                          )
                                        }
                                        icon={faQrcode}
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                          marginLeft: "10px",
                                          cursor: "pointer",
                                        }}
                                      />
                                    ) : (
                                      <FontAwesomeIcon
                                        title="Add"
                                        onClick={(ev) =>
                                          getData(
                                            ev,
                                            user?.connected_location?.find(
                                              (loc) =>
                                                loc?.location_server_id ==
                                                server.id
                                            ),
                                            user,
                                            server
                                          )
                                        }
                                        icon={faPlus}
                                        style={{
                                          width: "25px",
                                          height: "25px",
                                          marginLeft: "10px",
                                          cursor: "pointer",
                                          color: "green",
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div className="px-4 d-flex py-2 align-items-center justify-content-between flexColumn my3">
            <div className="d-flex pageCountColor my3">
              Showing
              <span className="ps-1 pageCountColor">
                {currentPage * usersPerPage - usersPerPage + 1}-
                {Math.min(currentPage * usersPerPage, recordCount)} of{" "}
                {recordCount}
              </span>
            </div>
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <i
                      className="fa fa-angle-left text-black"
                      aria-hidden="true"
                    ></i>
                  </button>
                </li>
                {renderPagination()}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <i
                      className="fa fa-angle-right text-black"
                      aria-hidden="true"
                    ></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      {/* {editModalOpen && ( */}
        <EditModal
          show={editModalOpen}
          user={selectedUser}
          onClose={handleClose}
          token={userToken}
          updateUser={updateUserList}
        />
      {/* )} */}
      <AddModal
        show={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        token={userToken}
        updateUser={updateUserList}
      />
    </section>
  );
}
